import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { openPopover } from '../../actions/popover'
import { changeSetting, saveSettings } from '../../actions/settings'
import { resendUserConfirmationEmail } from '../../actions/user'
import { openModal } from '../../actions/modal'
import {
  BREAKPOINT_EXTRA_SMALL,
  BREAKPOINT_MEDIUM,
  BREAKPOINT_LARGE,
  MODAL_EMAIL_CONFIRMATION_REMINDER,
  POPOVER_SHORTCUTS,
} from '../../constants'
import {
  me,
  meEmail,
  emailConfirmed,
} from '../../initial_state'
import { makeGetAccount } from '../../selectors'
import Responsive from '../../features/ui/util/responsive_component'
import {
  CX,
  THEMES,
  DEFAULT_THEME,
  POPOVER_NAV_SETTINGS,
} from '../../constants'
import Avatar from '../avatar'
import BackButton from '../back_button'
import Button from '../button'
import Heading from '../heading'
import Icon from '../icon'
import NavigationBarButton from '../navigation_bar_button'
import Search from '../search'
import Text from '../text'

class DefaultNavigationBar extends ImmutablePureComponent {

  handleOnClickLightBulb = () => {
    let index = THEMES.findIndex((t) => t === this.props.theme)
    const nextIndex = (index === THEMES.length -1) ? 0 : index += 1
    const newTheme = THEMES[nextIndex]
    this.props.onChange('theme', newTheme)
  }

  handleOnOpenNavSettingsPopover = () => {
    this.props.onOpenNavSettingsPopover(this.avatarNode)
  }

  handleOnClickResendConfirmationEmail = () => {
    const { emailConfirmationResends } = this.props
    if (emailConfirmationResends % 2 === 0 && emailConfirmationResends > 0) {
      this.props.onOpenEmailModal()
    }
    if (emailConfirmationResends > 10) {
      return console.warn("over the confirmation send limit")
    }
    this.props.onResendUserConfirmationEmail()
  }

  handleOnClickShortcuts = () => {
    this.props.onOpenShortcutsPopover(this.shortcutsNode)
  }

  setShortcutsNode = (c) => {
    this.shortcutsNode = c
  }

  setAvatarNode = (c) => {
    this.avatarNode = c
  }

  render() {
    const {
      title,
      showBackBtn,
      actions,
      tabs,
      account,
      noActions,
      logoDisabled,
      unreadChatsCount,
      notificationCount,
      width,
      page,
      shrinkSearch,
    } = this.props

    const currentPathname = window.location.pathname

    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const isMD = width <= BREAKPOINT_MEDIUM
    const isLG = width <= BREAKPOINT_LARGE

    const isNotifications = currentPathname.startsWith('/notifications')

    const navigationContainerClasses = CX({
      d: 1,
      z4: 1,
      transitionMinHeight025: 1,
      minH53PX: emailConfirmed,
      minH106PX: !emailConfirmed,
      w100PC: 1,
    })

    const innerNavigationContainerClasses = CX({
      d: 1,
      minH53PX: 1,
      bgNavigationOnly: page === 'home' && isXS,
      bgNavigation: !(page === 'home' && isXS),
      aiCenter: 1,
      z3: 1,
      top0: emailConfirmed,
      top53PX: !emailConfirmed,
      right0: 1,
      left0: 1,
      posFixed: 1,
      transitionTransform025: 1,
    })

    const rightContainerClasses = CX({
      d: 1,
      mlAuto: 1,
      flexRow: 1,
      jcEnd: 1,
      pr15: 1,
      w242PX: 1,
    })

    const isHome = title === 'Home'

    let homeTo = '/home'
    let homeClick = undefined
    if (isHome) {
      homeTo = undefined
      homeClick = () => {
        window.scrollTo(0,0)
      }
    }

    let notificationsTo = '/notifications'
    let notificationsClick = undefined
    if (isNotifications) {
      notificationsTo = undefined
      notificationsClick = () => {
        window.scrollTo(0,0)
      }
    }

    let groupsTo = '/groups'
    let groupsClick = undefined
    if (currentPathname.startsWith('/groups') && !currentPathname.startsWith('/groups/')) {
      groupsTo = undefined
      groupsClick = () => {
        window.scrollTo(0,0)
      }
    }

    return (
      <div id='nav' className={navigationContainerClasses}>

        {
          !emailConfirmed &&
          <div id='nav-email' className={[_s.d, _s.transitionTransform025, _s.posFixed, _s.top0, _s.right0, _s.left0, _s.z3, _s.h53PX, _s.w100PC, _s.bgNavigationBlend].join(' ')}>
            <div className={[_s.d, _s.aiCenter, _s.jcCenter, _s.saveAreaInsetPT, _s.saveAreaInsetPL, _s.saveAreaInsetPR, _s.flexRow, _s.w100PC, _s.h53PX, _s.mlAuto, _s.mrAuto].join(' ')}>
              <div className={[_s.mr15, _s.colorNavigation, _s.pl10].join(' ')}>
                <Responsive min={BREAKPOINT_EXTRA_SMALL}>
                  <Text color='inherit' size='small'>
                    Confirm your email address to access all of Gab's features.&nbsp;
                  </Text>
                </Responsive>
                <Text color='inherit' size='small' weight='medium'>
                  A confirmation message was sent to&nbsp;
                  <Responsive min={BREAKPOINT_EXTRA_SMALL}>
                    <Text weight='bold' color='inherit' size='small'>{meEmail}</Text>
                  </Responsive>
                  <Responsive max={BREAKPOINT_EXTRA_SMALL}>
                    you
                  </Responsive>
                </Text>
              </div>
              <Button
                isNarrow
                backgroundColor='secondary'
                color='secondary'
                className={_s.mr10}
                onClick={this.handleOnClickResendConfirmationEmail}
              >
                <Text color='inherit' weight='medium'>
                  Resend Confirmation
                </Text>
              </Button>
            </div>
          </div>
        }

        <div id='nav-container' className={innerNavigationContainerClasses}>

          <div className={[_s.d, _s.saveAreaInsetPT, _s.saveAreaInsetPL, _s.saveAreaInsetPR, _s.flexRow, _s.w100PC].join(' ')}>

            { /** Default */}
            <Responsive min={BREAKPOINT_EXTRA_SMALL}>

              <div className={[_s.d, _s.flexRow, _s.pl15, _s.w242PX].join(' ')}>

                <h1 className={[_s.d, _s.mr15].join(' ')}>
                  <Button
                    to='/'
                    isText
                    title='Gab'
                    aria-label='Gab'
                    color='none'
                    backgroundColor='none'
                    className={[_s.d, _s.jcCenter, _s.noSelect, _s.noUnderline, _s.h53PX, _s.cursorPointer].join(' ')}
                  >
                    <Icon id='logo' className={_s.fillNavigationBrand} minimizeLogo={logoDisabled} />
                  </Button>
                </h1>

                <div className={[_s.d, _s.maxW320PX, _s.flexGrow1, _s.pr15].join(' ')}>
                  <Search isInNav />
                </div>

              </div>

              <div className={[_s.d, _s.mlAuto].join(' ')}>
                {
                  !noActions &&
                  <div className={[_s.d, _s.h53PX, _s.py3, _s.flexRow, _s.aiCenter, _s.jcSpaceBetween].join(' ')}>
                    <NavigationBarButton title='Home' icon='home' isActive={isHome} to={homeTo} onClick={homeClick} isMD={isMD} />
                    <NavigationBarButton title='Explore' icon='explore' to='/explore' isMD={isMD} />
                    <NavigationBarButton title='Groups' icon='group' to={groupsTo} isActive={currentPathname.startsWith('/groups')} onClick={groupsClick} isMD={isMD} />
                    <NavigationBarButton title='News' icon='news' to='/news' isMD={isMD} />
                    <NavigationBarButton title='Businesses' icon='apps' to='/businesses' isMD={isMD} />
                    <NavigationBarButton title='Marketplace' icon='shop' to='/marketplace' isMD={isMD} />
                  </div>
                }
              </div>

              <div className={rightContainerClasses}>
                <NavigationBarButton attrTitle='Notifications' icon='notifications' to={notificationsTo} onClick={notificationsClick} count={notificationCount} />
                <NavigationBarButton attrTitle='Chats' icon='chat' to='/messages' count={unreadChatsCount} />
                <NavigationBarButton attrTitle='Shortcuts' icon='star' onClick={this.handleOnClickShortcuts} buttonRef={this.setShortcutsNode} />
                <NavigationBarButton attrTitle='Dark/Muted/Light/White Mode' icon='light-bulb' onClick={this.handleOnClickLightBulb} />
              
                {
                  !!account &&
                  <button
                    ref={this.setAvatarNode}
                    title={account.get('display_name')}
                    onClick={this.handleOnOpenNavSettingsPopover}
                    className={[_s.h53PX, _s.bgTransparent, _s.outlineNone, _s.cursorPointer, _s.d, _s.jcCenter, _s.ml5].join(' ')}
                  >
                    <Avatar account={account} size={34} noHover />
                  </button>
                }
              </div>

            </Responsive>
            
            { /** Mobile */}
            <Responsive max={BREAKPOINT_EXTRA_SMALL}>
              <div className={[_s.d, _s.aiStart, _s.pl10].join(' ')}>
                {
                  !!account && isHome &&
                  <button
                    title='Gab.com'
                    href='/'
                    className={[_s.h53PX, _s.bgTransparent, _s.outlineNone, _s.cursorPointer, _s.d, _s.jcCenter].join(' ')}
                  >
                    <Icon id='logo' className={_s.fillNavigationBrand} minimizeLogo={logoDisabled} />
                  </button>
                }
                {
                  showBackBtn && !isHome &&
                  <BackButton
                    className={_s.h53PX}
                    icon='angle-left'
                    iconSize='18px'
                    iconClassName={[_s.mr5, _s.fillNavigation].join(' ')}
                  />
                }
              </div>
              
              {
                !!title && !isHome &&
                <div className={[_s.d, _s.h53PX, _s.jcCenter].join(' ')}>
                  <Heading size='h1'>
                    <Text className={_s.colorNavigation} size='extraExtraLarge' weight='bold'>
                      {title}
                    </Text>
                  </Heading>
                </div>
              }

              <div className={[_s.d, _s.minW84PX, _s.pr7, _s.mlAuto].join(' ')}>
                <div className={[_s.d, _s.h100PC, _s.bgTransparent, _s.flexRow, _s.aiCenter, _s.jcCenter, _s.mlAuto].join(' ')}>
                  {
                    actions && actions.map((action, i) => {
                      if (typeof action === 'function' || !!action.component || action.type === 'component') {
                        return action.component
                      }

                      return (
                        <NavigationBarButton
                          attrTitle={action.attrTitle}
                          title={action.title}
                          icon={action.icon}
                          count={action.count}
                          to={action.to || undefined}
                          href={action.href || undefined}
                          buttonRef={action.buttonRef || undefined}
                          onClick={action.onClick ? () => action.onClick() : undefined}
                          key={`action-btn-${i}`}
                          isXS
                        />
                      )
                    })
                  }
                </div>
              </div>
            </Responsive>

          </div>

        </div>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  width: state.getIn(['settings', 'window_dimensions', 'width']),
  account: makeGetAccount()(state, me),
  emailConfirmationResends: state.getIn(['user', 'emailConfirmationResends'], 0),
  theme: state.getIn(['settings', 'displayOptions', 'theme'], DEFAULT_THEME),
  logoDisabled: state.getIn(['settings', 'displayOptions', 'logoDisabled'], false),
  notificationCount: state.getIn(['notifications', 'unread']),
  unreadChatsCount: state.getIn(['chats', 'chatsUnreadCount']),
})

const mapDispatchToProps = (dispatch) => ({
  onOpenNavSettingsPopover(targetRef) {
    dispatch(openPopover(POPOVER_NAV_SETTINGS, {
      targetRef,
      position: 'left-end',
    }))
  },
  onOpenShortcutsPopover(targetRef) {
    dispatch(openPopover(POPOVER_SHORTCUTS, {
      targetRef,
    }))
  },
  onOpenEmailModal() {
    dispatch(openModal(MODAL_EMAIL_CONFIRMATION_REMINDER))
  },
  onResendUserConfirmationEmail() {
    dispatch(resendUserConfirmationEmail())
  },
  onChange(key, value) {
    dispatch(changeSetting(['displayOptions', key], value))
    dispatch(saveSettings())
  },
})

DefaultNavigationBar.propTypes = {
  account: ImmutablePropTypes.map,
  actions: PropTypes.array,
  tabs: PropTypes.array,
  title: PropTypes.string,
  showBackBtn: PropTypes.bool,
  notificationCount: PropTypes.number.isRequired,
  unreadChatsCount: PropTypes.number.isRequired,
  onOpenNavSettingsPopover: PropTypes.func.isRequired,
  onOpenEmailModal: PropTypes.func.isRequired,
  onResendUserConfirmationEmail: PropTypes.func.isRequired,
  emailConfirmationResends: PropTypes.number.isRequired,
  noActions: PropTypes.bool,
  theme: PropTypes.string,
  page: PropTypes.string,
  logoDisabled: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultNavigationBar)